import { render, staticRenderFns } from "./ProgramStatsModal.vue?vue&type=template&id=51bc49d5&scoped=true&lang=pug&"
import script from "./ProgramStatsModal.vue?vue&type=script&lang=js&"
export * from "./ProgramStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStatsModal.vue?vue&type=style&index=0&id=51bc49d5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc49d5",
  null
  
)

export default component.exports